
export const GET_WORK_ORDER_STATUS = gql`
  query GetWorkOrderStatus($id: String!) {
    internalWorkOrder(id: $id) {
      id
      status
    }
  }
`